import React from 'react';
import { Box } from '@mui/material';
import { MainText } from "../globalStyles";
import { Text } from "../About/Styles";

const Contact = () => {

  return (

    <Box sx={{ pl: { sm: 12, xs: 3}, pr: { sm: 12, xs: 2}, pb: { sm: 4, xs: 20 }} }>

{/* 
<Box sx={{ display: "flex", justifyContent: "center", pb: { sm: 4, xs: 2} }} pt={4}>
        <Text sx={{ fontSize: { sm: "30px", xs: "15px" } }}>Book a Session</Text>
</Box>

      <Box pt={4} pb={6} mb={4} 
      sx={{ 
        pl:{ sm: 8, xs: 1},
        pr:{ sm: 8, xs: 1},
        backgroundColor: "#eadfe9",
        borderRadius: "15px",
        display: "flex",
        flexDirection: "column"
        }}>

      <MainText pb={4} sx={{ fontSize: { xs: "20px", sm: "30px" } }}>
            
        <b>I am not currently accepting new clients.</b>
    
      </MainText>
      <MainText sx={{ fontSize: { xs: "12px", sm: "22px" } }}>
            
            To  make an enquiry, email me at <a href="mailto:nicolakirkcounselling@proton.me">nicolakirkcounselling@proton.me</a>
    
      </MainText>

      <MainText sx={{ fontSize: { xs: "12px", sm: "22px" } }} pt={6}>
            
            Alternatively, call or send a text to 0746 834 5451
    
      </MainText>


    </Box> */}
    </Box>
  );
};

export default Contact;
